import React, { useState } from "react";
import { Modal, Input, Button, message } from "antd";
import { deleteSubscription } from "../../../services/integrations/klaviyoSubscriptionService";

export default function DisconnectModal({ visible, onClose, onDisconnect }) {
  const [confirmText, setConfirmText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleDisconnect = async () => {
    setSubmitting(true);
    try {
      await deleteSubscription();
      message.success("Klaviyo disconnected");
      setConfirmText("");
      onDisconnect();
      onClose();
    } catch (err) {
      message.error("Failed to disconnect Klaviyo integration");
    }
    setSubmitting(false);
  };

  const handleCancel = () => {
    setConfirmText("");
    onClose();
  };

  return (
    <Modal
      title="Disconnect Klaviyo Integration?"
      open={visible}
      onCancel={handleCancel}
      width={450}
      footer={[
        <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
        <Button
          key="disconnect"
          danger
          type="primary"
          onClick={handleDisconnect}
          loading={submitting}
          disabled={confirmText !== "DISCONNECT"}
        >
          Disconnect
        </Button>,
      ]}
    >
      <p style={{ fontSize: 13, color: "#555", lineHeight: 1.6 }}>
        This will disable all event and attribute mappings and stop sending data to Klaviyo
        for this client. Catalog items will be preserved.
      </p>
      <div style={{ marginTop: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>
          Type <strong>DISCONNECT</strong> to confirm
        </div>
        <Input
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="DISCONNECT"
        />
      </div>
    </Modal>
  );
}
